import { withProps } from 'recompose'
import React from 'react'

import NewVersionPrompt from '../components/NewVersionPrompt'
import {
  getChatAdminUser,
  getChatCfg,
  getGlobalChatroom,
} from '../app/selectors'
import { chatRoomRoute } from '../app/routes'
import content from '../content'
import ChatRoomIframe from '../addons/chat/ChatRoomIframe'

class AdminChatPage extends React.Component {
  render() {
    const { chatCfg, chatroom, admin } = this.props
    return (
      <div style={{ width: '100%', height: '100vh' }}>
        <ChatRoomIframe
          src={chatRoomRoute(chatCfg.appId, chatroom.id, 'full', admin.token)}
          title={`chat${chatroom.id}`}
        />
        <NewVersionPrompt />
      </div>
    )
  }
}

const withToken = withProps(ownProps => ({
  admin: getChatAdminUser(content, ownProps.match.params.key),
  chatroom: getGlobalChatroom(content), // default is global chat
  chatCfg: getChatCfg(content),
}))

export default withToken(AdminChatPage)



// WEBPACK FOOTER //
// ./src/containers/AdminChatPage.js